export default __webpack_public_path__ + "img/cc.9c19d845.jpg";